import React from 'react';
import styled from 'styled-components';

import { HeaderContainer, HeaderMixin } from '../../shared/styles';
import { NameColumn, UrlColumn } from './styles';

const SHeaderContainer = styled(HeaderContainer)`
  margin-bottom: 16px;
`;

const NameColumnHeader = styled(NameColumn)`
  ${HeaderMixin}
`;

const UrlColumnHeader = styled(UrlColumn)`
  ${HeaderMixin}
`;

export default function Header() {
  return (
    <SHeaderContainer>
      <NameColumnHeader>Name</NameColumnHeader>
      <UrlColumnHeader>URL</UrlColumnHeader>
    </SHeaderContainer>
  );
}
